module.exports = __webpack_public_path__ + "img/no-photo.b675d873.jpg";